// Copyright (c) 2015, Mightium Technologies Pvt. Ltd. and Contributors
// MIT License. See license.txt

if (mightium.require) {
	mightium.require("file_uploader.bundle.js");
} else {
	mightium.ready(function () {
		mightium.require("file_uploader.bundle.js");
	});
}
